"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_2 = require("react");
var BlTextInput_1 = __importDefault(require("../BlTextInput"));
var BlCircleRadio_1 = __importDefault(require("./BlCircleRadio"));
var BlCheckbox_1 = __importDefault(require("../BlCheckbox"));
var react_i18next_1 = require("react-i18next");
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var isPreDefinedLabel = function (options, label) {
    var values = options.map(function (o) { return o.label; });
    return values.includes(label);
};
var BlRadioGroup = function (_a) {
    var _b = _a.value, value = _b === void 0 ? '' : _b, options = _a.options, onChange = _a.onChange, isNaturalNumber = _a.isNaturalNumber, isNonNegativeNumber = _a.isNonNegativeNumber, _c = _a.hasInput, hasInput = _c === void 0 ? false : _c, _d = _a.freeDesignCheckbox, freeDesignCheckbox = _d === void 0 ? '' : _d, maxLength = _a.maxLength;
    var t = react_i18next_1.useTranslation('common').t;
    var _e = react_2.useState(isPreDefinedLabel(options, value) || value === freeDesignCheckbox
        ? ''
        : value || ''), inputValue = _e[0], setInputValue = _e[1];
    var _f = react_2.useState((freeDesignCheckbox && value === freeDesignCheckbox) || false), isChecked = _f[0], setIsChecked = _f[1];
    react_2.useEffect(function () {
        if (freeDesignCheckbox && !isChecked && value === freeDesignCheckbox) {
            onChange('');
        }
        freeDesignCheckbox && isChecked && onChange(freeDesignCheckbox);
    }, [isChecked]);
    var isSelected = react_1.useCallback(function (label) {
        return label === value;
    }, [value]);
    var onInputChange = function (label) {
        if (isPreDefinedLabel(options, label)) {
            setInputValue('');
        }
        onChange(label);
    };
    var onRadioChange = react_1.useCallback(function (label) {
        setInputValue('');
        onChange(label === value ? '' : label);
    }, [value]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: styles_module_scss_1.default.bl_radio_group },
            options.map(function (_a, index) {
                var label = _a.label, name = _a.name;
                return (react_1.default.createElement(BlCircleRadio_1.default, { key: index, checked: isSelected(label), onChange: function (label) {
                        return onRadioChange(label);
                    }, label: label, name: String(index + label), disabled: isChecked }));
            }),
            hasInput && (react_1.default.createElement(BlTextInput_1.default, { className: styles_module_scss_1.default.custom_input, value: inputValue, type: "number", isNaturalNumber: isNaturalNumber, isNonNegativeNumber: isNonNegativeNumber, onChange: function (value) {
                    setInputValue(value);
                }, onBlur: function () {
                    inputValue.length && onInputChange(inputValue);
                }, disabled: isChecked, maxLength: maxLength }))),
        freeDesignCheckbox && (react_1.default.createElement("div", { className: styles_module_scss_1.default.free_design },
            react_1.default.createElement(BlCheckbox_1.default, { label: t("FIELD_OPTIONS." + freeDesignCheckbox), checked: isChecked, onChange: function () { return setIsChecked(!isChecked); } })))));
};
exports.default = BlRadioGroup;
